import { conditionFilter } from "@@/shared/discounts/conditions/discount-condition-filter";
import type { OrderItem } from "@@/shared/orders/order-items/order-item";
import { sumPrices } from "@@/shared/prices/sum-prices";
import { sortBy } from "@@/utilities/sort";
import type { DiscountCalculator } from "../discount-calculator-type";
import type { BogoDiscount } from "./bogo-discount";

const bogoDiscountCalculator: DiscountCalculator<BogoDiscount> =
    (discount: BogoDiscount) => (items: OrderItem[]) => {
        const entitledItems = conditionFilter(discount, items);

        // How many times is the bogo applicable?
        const times = Math.floor(entitledItems.length / discount.numberOfItems);

        // Whats the sum of the "times" number of lowest prices of the entitled items
        const sorted = entitledItems.sort(
            sortBy(item => item.price.amountIncludingVat, "ASCENDING"),
        ); // TODO! MAKE SURE THEY ARE IN THE RIGHT ORDER
        // console.log(
        //     "BOGO SORTED ENTITLED ITEMS",
        //     sorted.map(item => item.price.amountIncludingVat)
        // );

        // Calculate discount price
        const discountPrice = sumPrices(
            sorted.slice(0, times).map(item => item.price),
        );
        return discountPrice;
    };

export { bogoDiscountCalculator };
